import moment from 'moment';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useNameChangeAPI, userMarketingModAPI } from '../../../api/accountAPI';
import { TYPE, URL } from '../../../constant';
import { useAlert, useAmplitude, useInput, useUserInfo } from '../../../hooks';
import { A } from '../../common';
import PwForm from '../../account/GM/mypage/PwForm';
import EmailForm from '../../account/GM/mypage/EmailForm';
import { handleTermsPage } from '../../../utils/utilityEtc';

function MyPageV2() {
  const history = useHistory();

  const { t, i18n } = useTranslation();
  const { info, setInfo } = useUserInfo();
  const { setAmplitudeLog } = useAmplitude();
  const [Alert] = useAlert();
  const [name, changeName] = useInput(info?.learnerName);
  const [isNameChange, setIsNameChange] = useState(false);

  const nameChangeAPICall = useCallback(async () => {
    if (!info || !name) return;

    const resp = await useNameChangeAPI({
      member: info?.userId,
      learner: info?.learnerId,
      mbrNm: name,
    });

    if (resp?.code === 'S000000') {
      setInfo({ learnerName: name })
      setIsNameChange();
      setAmplitudeLog({ eventCategory: 'account', eventName: '회원 정보변경' });
    }

  }, [info, name]);

  const handleChangeName = useCallback(() => {
    setIsNameChange(!isNameChange);
    changeName({ target: { name, value: info?.learnerName } })
  }, [isNameChange]);

  const handleMarketing = useCallback(async (e) => {
    const checked = e.target.checked;
    const { userId } = info;
    const Yn = checked ? 'Y' : 'N';
    const resp = await userMarketingModAPI({
      member: userId,
      item4: Yn
    })

    if (resp?.code === 'S000000') {
      setInfo({ marketing: Yn });
      let msg = '';
      const day = t(
        "MY_03_01.msg040",
        {
          y: moment().format("YYYY"),
          m: moment().format(i18n.language === 'en' ? 'MMMM' : 'MM'),
          d: moment().format("DD"),
        }
      )
      if (Yn === 'N') msg = `${t("MY_03_01.msg031")}<br/>${day}`
      else msg = `${t("MY_03_01.msg032")}<br/>${day}`

      if (msg) Alert(msg);
    }


  }, [info]);

  const handlePage = useCallback((path) => {
    if (path === '/login') {
      setAmplitudeLog({ eventCategory: 'account', eventName: '로그아웃 실행' });
    }
    history.push(path);
  }, [])

  return (
    <React.Fragment>
      <div className="header_top gb bg_sky">
        <div className="inner">
          <div className="btns_wrap cls">
            <div className="app_btn">
              <button 
                className="btn_exit"
                type="button"
                onClick={() => history.goBack()}
              >
                <img src="./static/images/icon/btn_back.svg" alt="" />
              </button>
            </div>
            <div className="tit_gm center_tit24">{i18n.language === 'ko'? '마이페이지' : 'My Page'}</div>
          </div>
        </div>
      </div>

      <div className="layout-def layout-sl bg_gray gb">
        <div className="container">
          <div className="inner">
            <div className="wirte_form lr">
              <section className="w672 w672_tb">
                <form>
                  <article className="mem">
                    <div className="part1">
                      <img src="./static/images/common/img_profilecha_th_01.svg" alt="" />
                    </div>
                    <div className="part2">
                      <div className="name_cont">
                        {
                          !isNameChange
                            ? (
                              <div className="name">
                                <span className="ellipsis">{name}</span>
                              </div>
                            )
                            : (
                              <div className="edit_area" style={{ display: isNameChange ? 'block' : 'none' }}>
                                <div className="input_box white_box">
                                  <input
                                    type="text"
                                    value={name}
                                    onChange={changeName}
                                  />
                                </div>
                              </div>
                            )
                        }
                      </div>
                      <div className="btns_cont">
                        {
                          !isNameChange 
                           ? (
                            <div className="toggle1">
                              <button 
                                type="button" 
                                className="mint_txt_btn js_toggle1"
                                onClick={handleChangeName}
                              >
                                {t("MY_03_01-GM.msg003")}
                              </button>
                            </div>
                           )
                           : (
                              <div className="toggle2" style={{ display: isNameChange ? 'block' : 'none' }}>
                                <button
                                  type="button"
                                  className="btn btn-blue js_toggle2"
                                  onClick={handleChangeName}
                                >{t("MY_03_01-GM.msg009")}</button>
                                <button
                                  type="button"
                                  className="btn btn-gray js_toggle2"
                                  onClick={nameChangeAPICall}
                                >{t("MY_03_01-GM.msg003")}</button>
                              </div>
                           )
                        }
                      </div>
                    </div>
                  </article>
                </form>
              </section>
              {
                info.memberType === TYPE.GB_USER_TYPE.GUEST
                 ? (
                    <>
                    <section className="w672 w672_tb">
                      <form>
                        <div className="item cls email">
                          <div className="input_title">{t("MY_03_01.msg002")}</div>
                          <button
                            type="button"
                            className="mint_txt_btn"
                            onClick={() => handlePage(URL.ACCOUNT.LOGIN)}
                          >
                            {t("MY_03_01.msg041")}
                          </button>
                        </div>
                      </form>
                    </section>
                    { info.isPaymentCountry && (
                      <section className="w672 w672_tb withdraw_sec cls">
                          <h2>{t("MY_03_01.msg042")}</h2>
                          <p>{t("MY_03_01.msg043")}</p>
                      </section>
                    )}
                    </>
                 )
                 : (
                  <>
                      <section className="w672 w672_tb">
                        <h2>{t("MY_03_01-GM.msg001")}</h2>
                        <EmailForm />
                        <PwForm
                          pwLength={6}
                        />
                      </section>
                      { info.isPaymentCountry && (
                        <section className="w672 w672_tb withdraw_sec cls">
                            <h2>{t("MY_03_01.msg042")}</h2>
                            <p>{t("MY_03_01.msg043")}</p>
                        </section>
                      )}
                      <section className="w672 w672_tb policy_sec">
                        <h2>{t("MY_03_01.msg006")}</h2>
                        <ul>
                          <li><A onClick={() => handleTermsPage('terms')}>{t("MY_03_01.msg007")}</A></li>
                          <li><A onClick={() => handleTermsPage('privacy')}>{t("MY_03_01.msg008")}</A></li>
                          <li>
                            <A onClick={() => handleTermsPage('marketing')}>{t("MY_03_01.msg030")}</A>
                            <div className="custom-radio-wrap gray">
                              <input
                                type="checkbox"
                                id="input-chk1"
                                checked={info?.marketing === 'Y'}
                                onChange={handleMarketing}
                              />
                              <label htmlFor="input-chk1">{t("MY_03_01.msg036")}</label>
                            </div>
                          </li>
                        </ul>
                      </section>
                      <section className="w672 w672_tb withdraw_sec cls">
                        <div className="left" dangerouslySetInnerHTML={{ __html: t("MY_03_01.msg009") }} />
                        <div className="right"><A onClick={() => handlePage('/leave')}>{t("MY_03_01.msg010")}</A></div>
                      </section>
                      <div className="logout w672 w672_tb">
                        <button className="btn btn-white" onClick={() => handlePage('/login')}>
                          {t("MY_03_01.msg011")}
                        </button>
                      </div>
                  </>
                 )
              }
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default MyPageV2;